import React from 'react';
import axios from 'axios';
import Header4 from '../../Header/Header4';
import './index.css';
import { connect } from "react-redux";
import {
    FileExcelOutlined,
    FileImageOutlined,
    FileJpgOutlined,
    FilePdfOutlined,
    FilePptOutlined,
    FileWordOutlined,
    LeftOutlined,
    PlaySquareOutlined,
    RightOutlined
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import FileViewer from "react-file-viewer";
import PDFViewer from "react-pdf-js";
import Base64 from "base-64";


const baseUrl = 'https://caplos.aircas.ac.cn/gateway/api/online-school';
const { Header, Content, Sider } = Layout;
const resourceIcon = {
    'mp4': <PlaySquareOutlined />,
    'docx': <FileWordOutlined />,
    'pdf': <FilePdfOutlined />,
    'pptx': <FilePptOutlined />,
    'ppt': <FilePptOutlined />,
    'doc': <FileWordOutlined />,
    'xlsx': <FileExcelOutlined />,
    'xls': <FileExcelOutlined />,
    'jpg': <FileJpgOutlined />,
    'png': <FileImageOutlined />,
}


class TrainingDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            courseId: '',
            classSelected: 0,
            classDetailData: [],
            collapsed: false,
            prevPage: undefined,
            pdfPageNum: 0,
            curPdfPage: 1,
        };
        this.prevPage = undefined;
    }

    componentDidMount() {
        if (this.props.location.state) {
            this.prevPage = this.props.location.state;
            this.setState({ prevPage: this.props.location.state });
        }
        let searchParams = new URLSearchParams(this.props.location.search);
        let courseId = searchParams.get('id');
        axios.get(baseUrl + `/resource/list/q?collectionId=${courseId}`).then(response => {
            this.setState({ classDetailData: response.data.data });
            let curClass = response.data.data[0];
            if (curClass !== undefined) {
                let timer = setInterval(() => {
                    if (this.props.user && this.props.user.userId) {
                        axios.post(baseUrl + `/progress/save?resourceId=${curClass.resourceId}&resourceName=${curClass.resourceName}&userId=${this.props.user.userId}`).then(r => {
                            if (r.data.code === 200) {
                                console.log(r.data.msg)
                            }
                        });
                        clearInterval(timer);
                    }
                }, 200)
            }
        });
    }

    classChange = ({ key }) => {
        let curClass = this.state.classDetailData[key];
        let timer = setInterval(() => {
            if (this.props.user && this.props.user.userId) {
                axios.post(baseUrl + `/progress/save?resourceId=${curClass.resourceId}&resourceName=${curClass.resourceName}&userId=${this.props.user.userId}`).then(r => {
                    if (r.data.code === 200) {
                        console.log(r.data.msg)
                    }
                });
                clearInterval(timer);
            }
        }, 200)
        this.setState({ classSelected: key });
    }

    handleBack = () => {
        if (this.prevPage) {
            this.props.history.push({ pathname: '/OnlineTraining', state: this.state.prevPage })
        } else {
            this.props.history.goBack();
        }
    }

    setPdfPages = (pages) => {
        this.setState({ pdfPageNum: pages, curPdfPage: 1 })
    }

    prevPdfPage = () => {
        this.setState(prevState => {
            if (prevState.curPdfPage > 1) {
                return { curPdfPage: prevState.curPdfPage - 1 }
            }
        })
    }

    nextPdfPage = () => {
        this.setState(prevState => {
            if (prevState.curPdfPage < prevState.pdfPageNum) {
                return { curPdfPage: prevState.curPdfPage + 1 }
            }
        })
    }

    getPrevUrl = (resourceUrl) => {
        console.log("resourceUrl", resourceUrl);
        let region = /caplos.aircas.ac.cn\/\/?oss/;
        let newResource = '';
        let fileType = resourceUrl.split('.').splice(-1)[0];
        let imageType = ['png', 'jpg', 'jpeg', 'mp4'];
        // kkFile组件预览图片时需要外网的地址，预览文件时需要内网的地址
        if (imageType.includes(fileType)) {
            newResource = resourceUrl;
        } else {
            // newResource = resourceUrl;
            newResource = resourceUrl.replace(region, global.filePrevUrl);
            newResource = newResource.replace('https', 'http');
        }
        console.log('zyg')
        // newResource = resourceUrl.replace(region, global.filePrevUrl);
        // // let newResource = "http://124.16.188.131:9599/oss/group1/M00/00/7C/rBIAAWTMl3SAWKQqADrSJjhCqQc621.mp4";
        console.log("newResource:", newResource, `${global.support.filePreview}/onlinePreview?url=${Base64.encode(newResource)}`);
        console.log("knowlageBaseResourceUrl:", resourceUrl);
        return `${global.support.filePreview}/onlinePreview?url=${Base64.encode(newResource)}`;
    }

    loadFile = () => {
        if (this.state.classDetailData.length !== 0) {
            let curClass = this.state.classDetailData[this.state.classSelected];
            console.log('curClass.resourceUrl:', curClass);
            return (// <>
                //     {curClass.resourceType === 'pdf' ?
                //         <div className="pdf_file_container">
                //             <LeftOutlined className="pdf_page_button" onClick={this.prevPdfPage}/>
                //             <div className="pdf_box">
                //                 <PDFViewer
                //                     fileType={curClass.resourceType}
                //                     file={curClass.resourceUrl}
                //                     onDocumentComplete={(pages) => this.setPdfPages(pages)}
                //                     page={this.state.curPdfPage}
                //                 />
                //             </div>
                //             <RightOutlined className="pdf_page_button" onClick={this.nextPdfPage}/>
                //         </div> :
                //         <div className="file_viewer">
                //             <FileViewer
                //                 fileType={curClass.resourceType}
                //                 filePath={curClass.resourceUrl}
                //                 onError={this.onError}
                //                 errorComponent={Error}
                //                 unsupportedComponent={Error}/>
                //             {/*<FileViewer*/}
                //             {/*    fileType={'pptx'}*/}
                //             {/*    filePath={'http://124.16.188.131:9599//oss/group1/M00/00/7C/rBIAAWTu8MKAXGFxAADnrp-Z5Sc60.pptx'}*/}
                //             {/*    onError={this.onError}*/}
                //             {/*    errorComponent={Error}*/}
                //             {/*    unsupportedComponent={Error}/>*/}
                //         </div>
                //     }
                // </>
                <div className="file_viewer">
                    <iframe className="file_window" src={this.getPrevUrl(curClass.resourceUrl)}></iframe>
                </div>)
        } else {
            return null;
        }
    }

    resourceLists = () => {
        if (this.state.classDetailData.length !== 0) {
            return (this.state.classDetailData.map((resource, index) => <Menu.Item className="class_item" key={index}
                icon={resourceIcon[resource.resourceType]}>
                {resource.resourceName}
            </Menu.Item>))
        }
    }

    render() {
        return (<>
            <Header4 />
            <div className='online_training_background'>
                <div className="preview_panel">
                    <Layout>
                        <Sider theme="light" width={250}>
                            <div className="directory_header">目录</div>
                            <Menu mode={'inline'} defaultSelectedKeys={[0]} onClick={this.classChange}>
                                {this.resourceLists()}
                            </Menu>
                        </Sider>
                        <Layout>
                            <Header className="course_name_header">
                                <div className="back_box" onClick={this.handleBack}>
                                    <LeftOutlined className="back_icon" />
                                    <div className="detail_back_font">返回</div>
                                </div>
                                <div
                                    className="course_name_font">{this.state.classDetailData.length !== 0 ? this.state.classDetailData[this.state.classSelected].collectionName : ''}</div>
                                <div className="back_box"></div>
                            </Header>
                            <Content
                                className="player_body"
                            >
                                {this.loadFile()}
                            </Content>
                        </Layout>
                    </Layout>
                </div>
            </div>
        </>)
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS(),
    collectionId: state.PageCacheReducer.collectionId,
    classDetail: state.PageCacheReducer.classObj,
})
const mapDispatch = (dispatch) => ({})


export default connect(mapState, mapDispatch)(TrainingDetail);